/* liftsets (BUILD-xxiii → BUILD-xxxiv): product-page helpers. No app, no third party, no
   MutationObserver — everything is event-driven (variantChange, ls:total, change, click, scroll,
   IntersectionObserver, ResizeObserver).
   1. Recently viewed: remembers the last 12 product handles in localStorage (key ls_recent) and
      renders them into any [data-ls-recent] section via /products/<handle>.js (Dawn card classes).
   2. Recommendations tabs, collapsed description, capped gallery thumbnails.
   3. Add-on funnel (radios, Show more, running total, echo, combined add-to-cart POST).
   4. Sticky total + add-to-cart bar; header hide-on-scroll-down below 990 px; dispatch weekday
      copy; "Often bought with" View more / progress bar / Search & Discovery fill.
   Nothing runs on pages without those hooks. */
(function () {
  'use strict';
  /* Owner rulings 17 Sep (bug found on the way): this file is requested by main-product AND the
     recommendations sections, so the browser runs it twice and every listener was bound twice —
     the funnel's "Show more" toggled open and shut in one click. Run once per page. */
  if (window.__lsPdpLoaded) return;
  window.__lsPdpLoaded = true;
  var KEY = 'ls_recent';
  var MAX = 12;

  function readList() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* private mode or storage blocked: recently viewed simply stays empty */
    }
  }

  function remember(handle) {
    if (!handle) return;
    var list = readList().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeList(list);
  }

  function money(cents) {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + width + 'x$1$2');
  }

  function card(p, fromLabel) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var priceText = money(p.price);
    if (p.price_varies) priceText = fromLabel.replace('%price%', priceText);
    var avail = p.available;
    return (
      '<li class="grid__item">' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      '<div class="card card--standard card--media">' +
      '<div class="card__inner ratio" style="--ratio-percent: 100%;">' +
      '<div class="card__media"><div class="media media--transparent media--hover-effect">' +
      (img
        ? '<img src="' + escapeHtml(imageUrl(img, 533)) + '" srcset="' + escapeHtml(imageUrl(img, 360)) + ' 360w, ' + escapeHtml(imageUrl(img, 533)) + ' 533w, ' + escapeHtml(imageUrl(img, 720)) + ' 720w" sizes="(min-width: 990px) 25vw, 50vw" alt="' + escapeHtml(p.title) + '" loading="lazy" width="533" height="533" class="motion-reduce">'
        : '') +
      '</div></div>' +
      (avail ? '' : '<div class="card__badge bottom left"><span class="badge badge--bottom-left color-scheme-2">Sold out</span></div>') +
      '</div>' +
      '<div class="card__content"><div class="card__information">' +
      '<h3 class="card__heading h5"><a href="/products/' + escapeHtml(p.handle) + '" class="full-unstyled-link">' + escapeHtml(p.title) + '</a></h3>' +
      '<div class="card-information"><div class="price"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">' + escapeHtml(priceText) + '</span></div></div></div></div>' +
      '</div></div></div></div></li>'
    );
  }

  function render(section) {
    var current = section.getAttribute('data-current-handle') || '';
    var limit = parseInt(section.getAttribute('data-limit') || '4', 10);
    var fromLabel = section.getAttribute('data-from-label') || 'From %price%';
    var list = readList().filter(function (h) { return h !== current; }).slice(0, limit);
    var target = section.querySelector('[data-ls-recent-list]');
    if (!list.length || !target) return;
    Promise.all(
      list.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var html = products.filter(Boolean).map(function (p) { return card(p, fromLabel); }).join('');
      if (!html) return;
      target.innerHTML = html;
      if (section.hasAttribute('data-ls-recent-tab')) {
        /* BUILD-xxxi: tabbed row — reveal the tab, the panel stays hidden until it is selected */
        var wrap = section.closest('[data-ls-recs]');
        var tab = wrap && wrap.querySelector('[data-ls-recs-tab="recent"]');
        if (tab) tab.hidden = false;
      } else {
        section.hidden = false;
      }
    });
  }

  /* BUILD-xxxi: recommendations tab pill (related | recently viewed) */
  function initRecsTabs() {
    document.querySelectorAll('[data-ls-recs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[data-ls-recs-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-ls-recs-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          wrap.querySelectorAll('[data-ls-recs-panel]').forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-ls-recs-panel') !== key;
          });
        });
      });
    });
  }

  /* BUILD-xxxi: collapsed description card with Show more / Show less */
  function initCollapsible() {
    document.querySelectorAll('[data-ls-collapsible-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('aria-controls');
      var body = id && document.getElementById(id);
      if (!body) return;
      var more = btn.querySelector('[data-ls-label-more]');
      var less = btn.querySelector('[data-ls-label-less]');
      /* short copy: nothing to collapse */
      if (body.scrollHeight <= body.clientHeight + 24) {
        body.classList.remove('is-collapsed');
        btn.hidden = true;
        return;
      }
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('is-collapsed') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (more) more.hidden = open;
        if (less) less.hidden = !open;
        if (!open) body.scrollIntoView({ block: 'nearest' });
      });
    });
  }

  /* Gallery thumbnails past the cap (snippets/product-media-gallery.liquid): reveal on the
     "Show all" button, or when the main slider moves past the visible thumbnails. */
  function revealThumbs(gallery) {
    if (!gallery) return;
    gallery.querySelectorAll('[data-ls-thumb-extra]').forEach(function (li) {
      li.removeAttribute('hidden');
      li.removeAttribute('data-ls-thumb-extra');
    });
    gallery.querySelectorAll('[data-ls-thumbs-more]').forEach(function (b) { b.remove(); });
    window.dispatchEvent(new Event('resize'));
  }

  function initThumbs() {
    document.querySelectorAll('[data-ls-thumbs-more]').forEach(function (btn) {
      var gallery = btn.closest('media-gallery');
      btn.addEventListener('click', function () { revealThumbs(gallery); });
      var mainSlider = gallery && gallery.querySelector('slider-component:not(.thumbnail-slider)');
      if (mainSlider) {
        mainSlider.addEventListener('slideChanged', function (e) {
          var visible = gallery.querySelectorAll('.thumbnail-list__item:not([hidden])').length;
          if (e.detail && e.detail.currentPage > visible) revealThumbs(gallery);
        });
      }
      gallery && gallery.addEventListener('click', function (e) {
        if (e.target.closest('.product__modal-opener, .thumbnail')) revealThumbs(gallery);
      }, { once: true });
    });
  }

  /* BUILD-xxxi → BUILD-xxxiv: guided add-on funnel (snippets/product-addons-funnel.liquid).
     - native radios, one name per step ("No bench" / "No rack" chip checked by default);
     - "Show N more" reveals the step's extra rows IN PLACE and moves focus to the first one;
       "Show fewer" hides them again and scrolls the step back under the header;
     - running total = main variant price × quantity + picked add-ons, written into the purchase
       card ([data-ls-total] — the column's one live region), the one-line echo under the step
       ("Bench +£79.99 · total £125.77") and, via the ls:total event, the sticky bar; the main
       price follows Dawn's variantChange event, the quantity follows the quantity input;
     - on Add to cart with at least one add-on picked, the main variant and the add-ons are posted
       together to /cart/add.js (items[], separate lines, no bundle pricing) with Dawn's cart
       sections, and Dawn's drawer or notification is re-rendered from that response. Without
       add-ons Dawn's own submit runs untouched. */
  function initAddons() {
    var root = document.querySelector('[data-ls-addons]');
    var total = document.querySelector('[data-ls-total]');
    var info = root && root.closest('.product__info-container');
    if (!info) info = total && total.closest('.product__info-container');
    var mainPrice = total ? parseInt(total.getAttribute('data-main-price') || '0', 10) : 0;

    function pickedInputs() {
      if (!root) return [];
      return Array.prototype.slice.call(root.querySelectorAll('[data-ls-addon-input]:checked')).filter(function (i) {
        return parseInt(i.value, 10) > 0;
      });
    }

    function quantity() {
      var q = info && info.querySelector('input[name="quantity"]');
      return (q && parseInt(q.value, 10)) || 1;
    }

    function updateEchoes(sum) {
      if (!root) return;
      root.querySelectorAll('[data-ls-addon-step]').forEach(function (step) {
        var echo = step.querySelector('[data-ls-addon-echo]');
        if (!echo) return;
        var picked = step.querySelector('[data-ls-addon-input]:checked');
        if (!picked || !(parseInt(picked.value, 10) > 0)) { echo.hidden = true; echo.textContent = ''; return; }
        echo.textContent = (picked.getAttribute('data-short') || picked.getAttribute('data-title')) + ' ' + (picked.getAttribute('data-delta') || '') + ' · total ' + money(sum);
        echo.hidden = false;
      });
    }

    function updateTotal() {
      var picked = pickedInputs();
      var sum = mainPrice * quantity();
      picked.forEach(function (i) { sum += parseInt(i.getAttribute('data-price') || '0', 10); });
      var count = quantity() + picked.length;
      if (total) {
        var value = total.querySelector('[data-ls-total-value]');
        var countOut = total.querySelector('[data-ls-total-count]');
        var unit = total.querySelector('[data-ls-total-unit]');
        var note = total.querySelector('[data-ls-total-note]');
        if (value) value.textContent = money(sum);
        if (countOut) countOut.textContent = String(count);
        if (unit) unit.textContent = count === 1 ? 'item' : 'items';
        if (note) note.hidden = picked.length === 0;
        total.hidden = false;
      }
      updateEchoes(sum);
      document.dispatchEvent(new CustomEvent('ls:total', { detail: { total: sum, count: count, text: money(sum) } }));
    }

    /* multi-variant add-ons: the size select shows only on the selected row; choosing a size sets
       the radio's variant id, price and exact delta (owner fact 17 Sep: single-variant products —
       every bench, most racks — never get a select; their row is a fixed "+£X") */
    function syncVariantSelects(step) {
      step.querySelectorAll('[data-ls-addon-variant]').forEach(function (wrap) {
        var li = wrap.closest('.ls-funnel__option');
        var input = li && li.querySelector('[data-ls-addon-input]');
        wrap.hidden = !(input && input.checked);
      });
    }
    function applyVariantChoice(select) {
      var li = select.closest('.ls-funnel__option');
      var input = li && li.querySelector('[data-ls-addon-input]');
      var opt = select.options[select.selectedIndex];
      if (!input || !opt) return;
      input.value = opt.value;
      input.setAttribute('data-price', opt.getAttribute('data-price') || '0');
      input.setAttribute('data-delta', '+' + money(parseInt(opt.getAttribute('data-price') || '0', 10)));
      var priceOut = li.querySelector('[data-ls-addon-price]');
      if (priceOut) priceOut.textContent = input.getAttribute('data-delta');
    }

    if (root) {
      root.querySelectorAll('[data-ls-addon-step]').forEach(function (step) {
        step.querySelectorAll('[data-ls-addon-input]').forEach(function (input) {
          input.addEventListener('change', function () {
            syncVariantSelects(step);
            var sel = input.checked && input.closest('.ls-funnel__option') && input.closest('.ls-funnel__option').querySelector('[data-ls-addon-variant-select]');
            if (sel) applyVariantChoice(sel);
            updateTotal();
          });
        });
        step.querySelectorAll('[data-ls-addon-variant-select]').forEach(function (sel) {
          sel.addEventListener('change', function () { applyVariantChoice(sel); updateTotal(); });
        });
        var more = step.querySelector('[data-ls-addon-more]');
        if (more) {
          more.addEventListener('click', function () {
            var open = more.getAttribute('aria-expanded') === 'true';
            var extras = step.querySelectorAll('[data-ls-addon-extra]');
            extras.forEach(function (li) { li.hidden = open; });
            more.setAttribute('aria-expanded', open ? 'false' : 'true');
            more.textContent = open ? (more.getAttribute('data-more-label') || 'Show more') : (more.getAttribute('data-less-label') || 'Show fewer');
            if (!open) {
              var first = extras[0] && extras[0].querySelector('input:not(:disabled)');
              if (first) first.focus({ preventScroll: true });
            } else {
              /* Show fewer: bring the step back under the sticky header */
              var top = step.getBoundingClientRect().top + window.scrollY - 100;
              if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'auto' });
            }
          });
        }
      });
    }

    /* BUILD-xxxi correction: PUB_SUB_EVENTS is a top-level const in constants.js, not a window
       property — test it with typeof, or the total never follows the variant. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        if (v && typeof v.price === 'number') { mainPrice = v.price; updateTotal(); }
      });
      subscribe(PUB_SUB_EVENTS.quantityUpdate, updateTotal);
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') updateTotal();
    });
    if (total || root) updateTotal();

    if (!root) return;
    /* BUILD-xxxiii buy box: only the MAIN product form (product-form-<section id>) carries the
       add-ons — the Often Bought With quick-add forms share data-type="add-to-cart-form" and used
       to be intercepted too (a ticked bench would have been posted with a quick-added rack). */
    var mainFormId = 'product-form-' + (root.getAttribute('data-section') || '');
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (form.getAttribute('id') !== mainFormId) return;
      var addons = pickedInputs().map(function (i) { return parseInt(i.value, 10); });
      if (!addons.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var data = new FormData(form);
      var mainId = parseInt(data.get('id'), 10);
      var qty = parseInt(data.get('quantity'), 10) || 1;
      if (!mainId) return;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var items = [{ id: mainId, quantity: qty }].concat(addons.map(function (id) { return { id: id, quantity: 1 }; }));
      var body = { items: items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      }
      /* form.id is shadowed by the <input name="id"> control — read the attribute */
      var formId = form.getAttribute('id');
      var buttons = Array.prototype.slice.call(document.querySelectorAll('[type="submit"][form="' + formId + '"], #' + formId + ' [type="submit"]'));
      buttons.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.classList.add('loading'); });
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            var err = form.querySelector('.product-form__error-message');
            var wrap = err && err.closest('.product-form__error-message-wrapper');
            if (err) { err.textContent = res.description || res.message; }
            if (wrap) wrap.hidden = false;
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: mainId, cartData: res });
          }
          if (cart && cart.renderContents) {
            /* as Dawn's product-form does: the drawer element carries is-empty until the first add */
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            if (res.items && res.items.length && !res.id) {
              var main = res.items[0];
              Object.keys(main).forEach(function (k) { if (!(k in res)) res[k] = main[k]; });
            }
            cart.renderContents(res);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; })
        .finally(function () {
          buttons.forEach(function (b) { b.removeAttribute('aria-disabled'); b.classList.remove('loading'); });
        });
    }, true);
  }

  /* BUILD-xxxiv: sticky total + add-to-cart bar (snippets/product-sticky-atc.liquid).
     Shown whenever the inline add-to-cart button is NOT intersecting the viewport (including before
     the user reaches it), hidden while it is; the CSS hides it while the cookie banner is open. The
     body reserves exactly the bar's rendered height (--ls-sticky-h). State follows events only:
     variantChange (short variant label + button state) and ls:total (the amount). */
  function initSticky() {
    var bar = document.querySelector('[data-ls-sticky]');
    if (!bar) return;
    var sectionId = bar.getAttribute('data-section') || '';
    var btn = bar.querySelector('button');
    var priceOut = bar.querySelector('[data-sticky-price]');
    var varOut = bar.querySelector('[data-sticky-variant]');
    var inline = document.getElementById('ProductSubmitButton-' + sectionId);
    function shortVariant() {
      /* the selects are re-rendered on every change, so query each time; single-value options
         ("Set: Pairs") are hidden and skipped */
      var parts = [];
      document.querySelectorAll('variant-selects select').forEach(function (select) {
        if (select.closest('.product-form__input--single')) return;
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var t = (opt.text || '').split(' — ')[0].split(' (')[0].trim();
        if (t) parts.push(t.replace(/(\d)kg\b/g, '$1 kg'));
      });
      return parts.length ? parts.join(' · ') : null;
    }
    function syncButton() {
      if (!inline || !btn) return;
      btn.disabled = inline.disabled || inline.getAttribute('aria-disabled') === 'true';
      var label = inline.querySelector('span');
      if (label && btn.firstElementChild) btn.firstElementChild.textContent = label.textContent.trim();
    }
    document.addEventListener('ls:total', function (e) {
      if (priceOut && e.detail && e.detail.text) priceOut.textContent = e.detail.text;
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        var sv = shortVariant();
        if (varOut) varOut.textContent = sv || (v && v.title) || '';
        /* Dawn toggles the inline button before it publishes; the total follows on ls:total */
        syncButton();
      });
    }
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        var h = bar.hidden ? 0 : bar.offsetHeight;
        if (h) document.documentElement.style.setProperty('--ls-sticky-h', h + 'px');
      }).observe(bar);
    }
    if (!inline || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { threshold: 0 }).observe(inline);
  }

  /* BUILD-xxxiv: on phones and tablets (< 990 px) the sticky header hides on scroll-down and
     returns on scroll-up (Dawn's "on-scroll-up" behaviour) so the buying column keeps the whole
     viewport; ≥ 990 px keeps the store's "always" setting. The header section's setting is not
     changed — Dawn's StickyHeader element is switched at runtime on product pages only. */
  function initHeaderScrollUp() {
    if (!document.querySelector('product-info')) return;
    var mq = window.matchMedia('(max-width: 989px)');
    function apply() {
      var sh = document.querySelector('sticky-header');
      if (!sh) return;
      if (mq.matches) {
        if (sh.headerIsAlwaysSticky !== false) {
          sh.dataset.lsWasAlways = sh.headerIsAlwaysSticky ? '1' : '';
          sh.headerIsAlwaysSticky = false;
          if (sh.header && sh.reset && window.scrollY <= 0) sh.reset();
        }
      } else if (sh.dataset.lsWasAlways === '1') {
        sh.headerIsAlwaysSticky = true;
        if (sh.header) {
          sh.header.classList.remove('shopify-section-header-hidden');
          sh.header.classList.add('shopify-section-header-sticky');
        }
      }
    }
    var ready = window.customElements && customElements.whenDefined ? customElements.whenDefined('sticky-header') : Promise.resolve();
    ready.then(apply).catch(function () {});
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  /* BUILD-xxxiv: dispatch line weekday logic (no countdown). The server renders
     "Order by 2pm Mon–Fri, dispatched same day"; on the device, on a business day before the
     cut-off it reads "Order by 2pm today, dispatched same day", otherwise
     "Order now for dispatch Monday" (next business day that is not a blackout date). Times in
     Europe/London, from the commercial_promise metaobject's cut-off, business days and blackout
     dates. */
  function initDispatch() {
    var el = document.querySelector('[data-ls-dispatch]');
    if (!el || !window.Intl || !Intl.DateTimeFormat) return;
    var cutoff = (el.getAttribute('data-cutoff') || '').split(':');
    var cutMin = parseInt(cutoff[0], 10) * 60 + (parseInt(cutoff[1], 10) || 0);
    if (isNaN(cutMin)) return;
    var days = (el.getAttribute('data-days') || '').split(',').map(function (d) { return d.trim().slice(0, 3).toLowerCase(); }).filter(Boolean);
    var blackout = (el.getAttribute('data-blackout') || '').split(',').map(function (d) { return d.trim(); }).filter(Boolean);
    var label = el.getAttribute('data-cutoff-label') || '2pm';
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    } catch (e) { return; }
    function parts(date) {
      var o = {};
      fmt.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
      return { weekday: o.weekday, iso: o.year + '-' + o.month + '-' + o.day, minutes: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
    }
    function isBusiness(p) {
      return days.indexOf(p.weekday.slice(0, 3).toLowerCase()) !== -1 && blackout.indexOf(p.iso) === -1;
    }
    var now = new Date();
    var today = parts(now);
    if (isBusiness(today) && today.minutes < cutMin) {
      el.textContent = 'Order by ' + label + ' today, dispatched same day';
      return;
    }
    for (var i = 1; i <= 14; i++) {
      var next = parts(new Date(now.getTime() + i * 86400000));
      if (isBusiness(next)) {
        el.textContent = 'Order now for dispatch ' + (i === 1 ? 'tomorrow' : next.weekday);
        return;
      }
    }
  }

  /* BUILD-xxxiv → BUILD-xxxv: "Often bought with" (snippets/product-pairs-with.liquid, ls-obw__*).
     - desktop: "View more" reveals the next page of server-rendered cards, "View less" folds them
       back; phones show every card in the 2-up snap strip with a progress bar;
     - BUILD-xxxv: cards come ONLY from the product's custom.often_bought_with metafield (server
       rendered); the Search & Discovery fill and its client-side card template are gone — a blank
       metafield means the block is not in the DOM at all. */
  function initObw() {
    document.querySelectorAll('[data-ls-obw]').forEach(function (wrap) {
      var grid = wrap.querySelector('[data-ls-obw-grid]');
      var btn = wrap.querySelector('[data-ls-obw-more]');
      var per = parseInt(wrap.getAttribute('data-per-page') || '3', 10);
      if (!grid) return;

      function refreshMore() {
        if (!btn) return;
        var extras = grid.querySelectorAll('[data-ls-obw-extra]');
        var hiddenCount = Array.prototype.filter.call(extras, function (li) { return li.hidden; }).length;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.hidden = extras.length === 0;
        var label = btn.querySelector('[data-ls-obw-more-label]') || btn;
        label.textContent = open ? (btn.getAttribute('data-less-label') || 'View less') : (btn.getAttribute('data-more-label') || 'View more') + (hiddenCount ? ' (' + hiddenCount + ')' : '');
      }
      if (btn) {
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          var extras = grid.querySelectorAll('[data-ls-obw-extra]');
          if (open) {
            extras.forEach(function (li) { li.hidden = true; });
            btn.setAttribute('aria-expanded', 'false');
            var top = wrap.getBoundingClientRect().top + window.scrollY - 100;
            if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'auto' });
          } else {
            var hiddenOnes = Array.prototype.filter.call(extras, function (li) { return li.hidden; });
            hiddenOnes.slice(0, per).forEach(function (li) { li.hidden = false; });
            if (!grid.querySelector('[data-ls-obw-extra][hidden]')) btn.setAttribute('aria-expanded', 'true');
          }
          refreshMore();
        });
        refreshMore();
      }

      /* progress bar for the phone strip */
      var bar = wrap.querySelector('[data-ls-obw-progress]');
      var thumb = bar && bar.querySelector('.ls-obw__progress-thumb');
      function progress() {
        if (!thumb) return;
        var max = grid.scrollWidth - grid.clientWidth;
        var frac = grid.clientWidth / Math.max(grid.scrollWidth, 1);
        thumb.style.width = Math.max(10, Math.round(frac * 100)) + '%';
        var x = max > 0 ? grid.scrollLeft / max : 0;
        thumb.style.transform = 'translateX(' + (x * (100 / Math.max(frac, 0.1) - 100)) + '%)';
      }
      grid.addEventListener('scroll', progress, { passive: true });
      window.addEventListener('resize', progress, { passive: true });
      progress();
    });
  }

  function init() {
    var root = document.querySelector('[data-ls-recent-product]');
    if (root) remember(root.getAttribute('data-ls-recent-product'));
    document.querySelectorAll('[data-ls-recent]').forEach(render);
    initThumbs();
    initRecsTabs();
    initCollapsible();
    initAddons();
    initSticky();
    initHeaderScrollUp();
    initDispatch();
    initObw();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
